import { Route } from "vue-router/types"
import { ROUTE_SITECORE_JSS } from "~/constants/routes"

const sitecoreRouteRegExp = new RegExp(`^${ROUTE_SITECORE_JSS}`)

export function getRouteName ({ name, params }: Route) {
  if (!name) return ''

  if (sitecoreRouteRegExp.test(name)) {
    // On sitecore routes
    // 1. we have no route names!
    // 2. they exist as the param and live on a single nuxt route
    return params.pathMatch.replace(new RegExp('/', 'g'), '-')
  }
  
  // On standard routes remove the i18n suffix
  return name.split('__')[0]
}
